import React from "react";

import book2 from "../assets/images/english primer.jpg";
import book3 from "../assets/images/MATH pre-primer.jpg";
import book4 from "../assets/images/picture book a.jpg";

import book5 from "../assets/images/DRAWINGA.jpg";

import book6 from "../assets/images/number.jpg";

import book7 from "../assets/images/small writing.jpg";

import book8 from "../assets/images/alphabet.jpg";

export const Content = () => {

  const latest = [

    book2,

    book3,

    book4,

  ];

  const flipbooks = [

    book5,

    book6,

    book7,

    book8,

  ];

  return (

    <section className="bg-[#FFF9F4] py-10">

      <div className="max-w-8xl mx-auto px-6">

        {/* Latest */}

        <div className="text-center mb-16">

          <div className="inline-block px-5 py-2 rounded-full bg-[#E8FFF7] text-[#6BCB77] font-semibold">

            ⭐ Latest Updates

          </div>

          <h2 className="text-5xl font-bold text-[#4D96FF] mt-5">

            Latest From Bhavya Publications

          </h2>

        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-24">

          {latest.map((item, index) => (

            <div
              key={index}

              className="bg-white rounded-3xl p-5 shadow-lg hover:-translate-y-3 hover:shadow-2xl transition"
            >

              <img
                src={item}

                alt="book"

                className="rounded-2xl"
              />

            </div>

          ))}

        </div>

        {/* Flipbooks */}

        <div className="text-center mb-16">

          <div className="inline-block px-5 py-2 rounded-full bg-[#FFF0F0] text-[#FF6B6B] font-semibold">

            🏆 Popular Books

          </div>

          <h2 className="text-5xl font-bold text-[#4D96FF] mt-5">

            Our Top Books

          </h2>

        </div>

        <div className="grid md:grid-cols-4 gap-8">

          {flipbooks.map((item, index) => (

            <div
              key={index}

              className="bg-white rounded-3xl p-5 shadow-lg hover:-translate-y-4 hover:rotate-1 hover:shadow-2xl transition duration-300"
            >

              <img
                src={item}

                alt="flipbook"

                className="rounded-2xl h-80 object-cover w-full"
              />

            </div>

          ))}

        </div>

      </div>

    </section>

  );
};